(function () {
  function variantState(variant, forceSoldOut, purchaseLabel) {
    var enabled = Boolean(variant && variant.available && !forceSoldOut);
    return {
      enabled: enabled,
      label: enabled ? (purchaseLabel || '購入する') : 'SOLD OUT',
      price: variant ? variant.price : null,
      compareAtPrice: variant ? variant.compare_at_price : null
    };
  }

  function formatMoney(cents, template) {
    var moneyTemplate = template || '¥{{amount_no_decimals}}';
    return moneyTemplate.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_match, token) {
      var amount = Number(cents) / 100;
      var noDecimals = token.indexOf('no_decimals') !== -1;
      var separator = token.indexOf('space') !== -1 ? ' ' : token.indexOf('apostrophe') !== -1 ? "'" : token.indexOf('comma_separator') !== -1 ? '.' : ',';
      var fixed = amount.toFixed(noDecimals ? 0 : 2);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);
      return parts.join(noDecimals ? '' : token.indexOf('comma_separator') !== -1 || token.indexOf('space_separator') !== -1 ? ',' : '.');
    });
  }

  function initProduct(root) {
    if (!root || root.dataset.kokiPurchaseReady === 'true') return;
    root.dataset.kokiPurchaseReady = 'true';
    var json = root.querySelector('[data-koki-variants]');
    var input = root.querySelector('[data-koki-variant-id]');
    if (!json || !input) return;
    var variants = JSON.parse(json.textContent || '[]');
    var selector = root.querySelector('[data-koki-variant-select]');
    var forceSoldOut = root.dataset.kokiForceSoldOut === 'true';
    var compareEnabled = root.dataset.kokiCompareEnabled === 'true';
    var moneyFormat = root.dataset.kokiMoneyFormat;
    var purchaseLabel = root.dataset.kokiPurchaseLabel;

    function update() {
      var selectedId = selector ? selector.value : input.value;
      var variant = variants.find(function (item) { return String(item.id) === String(selectedId); });
      var state = variantState(variant, forceSoldOut, purchaseLabel);
      input.value = variant ? variant.id : '';
      root.querySelectorAll('[data-koki-purchase-control]').forEach(function (button) {
        button.disabled = !state.enabled;
        button.setAttribute('aria-disabled', String(!state.enabled));
        button.textContent = state.label;
      });

      var price = variant ? formatMoney(variant.price, moneyFormat) : '';
      var hasCompare = Boolean(compareEnabled && variant && variant.compare_at_price > variant.price);
      var comparePrice = hasCompare ? formatMoney(variant.compare_at_price, moneyFormat) : '';
      var discount = hasCompare ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '% OFF' : '';
      root.querySelectorAll('[data-koki-price]').forEach(function (node) { node.textContent = price; });
      root.querySelectorAll('[data-koki-compare-price]').forEach(function (node) {
        node.textContent = comparePrice;
        node.hidden = !hasCompare;
      });
      root.querySelectorAll('[data-koki-compare-wrap]').forEach(function (node) { node.hidden = !hasCompare; });
      root.querySelectorAll('[data-koki-sticky-sale-label]').forEach(function (node) { node.hidden = !hasCompare; });
      root.querySelectorAll('[data-koki-discount]').forEach(function (node) {
        node.textContent = discount;
        node.hidden = !hasCompare;
      });
      root.querySelectorAll('[data-koki-price-display]').forEach(function (node) {
        node.classList.toggle('koki-price-pair', hasCompare);
        node.classList.toggle('koki-price-single', !hasCompare);
        node.classList.toggle('koki-price-pair--compact', hasCompare && node.hasAttribute('data-koki-compact'));
      });
      root.querySelectorAll('[data-koki-meta-compare-row], [data-koki-meta-discount-row], [data-koki-accordion-compare], [data-koki-accordion-discount]').forEach(function (node) {
        node.hidden = !hasCompare;
      });
    }

    if (selector) selector.addEventListener('change', update);
    update();
  }

  function init() {
    document.querySelectorAll('[data-koki-product]').forEach(initProduct);
  }
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', function (event) {
      initProduct(event.target.querySelector('[data-koki-product]'));
    });
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { variantState: variantState, formatMoney: formatMoney, initProduct: initProduct };
  }
})();
